import axios from 'axios'

const API=axios.create({baseURL:'https://communityapi.gsscore.com/'});

// const API=axios.create({baseURL:'http://localhost:5000/'});


//USERS
export const USERS_API = ()=>API.get(`users`);
export const GET_USER_DETAILS_API = (id)=>API.get(`users/${id}`);
export const FOLLOW_USER_API = (form_data,follow_userId)=>API.put(`users/${follow_userId}/follow`,form_data);
export const UNFOLLOW_USER_API = (form_data,follow_userId)=>API.put(`users/${follow_userId}/unfollow`,form_data);

// POST
export const USER_TIMELINEPOST_API = (user_id)=>API.get(`post/${user_id}/timeline`,FormData);
export const USER_PROFILE_TIMELINEPOST_API = (user_id)=>API.get(`post/${user_id}/profile-timeline`,FormData);
export const USER_CREATE_POST_API = (form_data,config)=>API.post(`post`,form_data,config);
export const CREATE_POST_COMMENT_API = (form_data,id)=>API.post(`post/${id}/comment`,form_data);
export const CREATE_POST_LIKE_API = (form_data,id)=>API.put(`post/${id}/like`,form_data);
//ACTIVITY
export const USER_CREATE_ACTIIVTY_API = (form_data,config)=>API.post(`activity`,form_data,config);
export const GET_USER_ACTIIVITY_OR_POST_BY_ID_API = (id)=>API.get(`post/${id}`);
export const UPDATE_USER_ACTIIVITY_BY_ID_API = (form_data,config,id)=>API.put(`activity/${id}`,form_data,config);

// THREAD
export const THREAD_LIST_API = ()=>API.get(`thread`,);
export const USER_THREADS_TIMELINE_API = (user_id,page=1,limit=9,filter='')=>API.get(`thread/${user_id}/timeline?page=${page}&limit=${limit}&filter=${filter}`,);

export const THREAD_DETAILS_WITH_PAGINATION_API = (id,page=1,limit=9,tag='')=>API.get(`thread/${id}/with_pagination?page=${page}&limit=${limit}&tag=${tag}`,);

export const THREAD_DETAILS_API = (id='')=>API.get(`thread/${id}`,);
export const CREATE_THREAD_API = (form_data)=>API.post(`thread`,form_data);
export const CREATE_THREAD_REPLY_API = (form_data,id)=>API.post(`thread/reply/${id}`,form_data);
export const CREATE_THREAD_LIKE_API = (form_data,id)=>API.put(`thread/${id}/like`,form_data);

//TAGS
export const TAGS_LIST_API = ()=>API.get(`tags`);

// reports
export const REPORT_TYPES_API = ()=>API.get(`report/types`);
export const CREATE_REPORT_API = (form_data)=>API.post(`report`,form_data);

